import React from "react";
import { Switch, Route } from "react-router-dom";
import PublicViews from "views/public-views";
import Loading from "components/shared-components/Loading";
import { useThemeSwitcher } from "react-css-theme-switcher";

export const PublicLayout = () => {
  const { status } = useThemeSwitcher();

  if (status === "loading") {
    return <Loading cover="page" />;
  }

  return (
    <div className="public-container">
      <Switch>
        <Route path="" component={PublicViews} />
      </Switch>
    </div>
  );
};

export default PublicLayout;
